<template>
  <div class="coupon-preview  w-2/3 m-auto py-32" v-loading="isLoading || !coupon">
    <h3 class="coupon-preview__title text-center m-auto text-grey-darkest text-xl font-medium mb-8">{{ $t('redemptionCoupon') }}</h3>
    <span class="coupon-preview__desc text-center m-auto text-grey-darkest text-base" v-if="!!coupon">{{ $t('congratsMsgOfCoupon', {nights: coupon.count})}}
      <!-- <span v-if="coupon.discountUnit === 'price'">
        $ {{ coupon.discountValue | toCurrency }} <small>{{ coupon.currency }}</small>
      </span>
      <span v-if="coupon.discountUnit === 'percent'">
        {{ 1 - coupon.discountValue | toPercentage }}%
      </span> -->
      {{ displayCouponCount(coupon) }}
      {{ $t('discountCoupon') }}</span>
    <CouponCard class="coupon-preview__card m-auto" v-if="!!coupon" :coupon="coupon" isShadow></CouponCard>
    <div class="coupon-preview__btn ">
      <button class="btn btn-orange btn-solid m-auto" @click="getRewardCoupon">{{ $t('getRedeem') }}</button>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import { mapActions, mapGetters } from 'vuex'

import CouponCard from '@/views/User/UserPoints/components/CouponCard'

export default {
  name: 'couponPreview',
  components: {
    CouponCard
  },
  filters: {
    toPercentage: function (val) {
      return 100 - val * 100
    }
  },
  props: {
    data: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data () {
    return {
      isLoading: false,
      coupon: null
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency'
    }),
    isCurrencyConvert: function () {
      return this.coupon.currency !== this.selectedCurrency
    }
  },
  methods: {
    ...mapActions(['user/addCouponVaiNight', 'user/getCouponNightPreview']),
    displayCouponCount: function (coupon) {
      if (coupon.discountUnit === 'percent') {
        return numeral((Number(1 - coupon.discountValue) * 100)).format('0[.]00') + '% OFF'
      } else {
        const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
        if (this.isCurrencyConvert) {
          return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency })
        } else {
          return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency }))
        }
      }
    },
    getRewardCoupon () {
      this.isLoading = true
      return this['user/addCouponVaiNight']().then(res => {
        if (res.status === 200 && this.data.callback) this.data.callback()
      }).finally(() => {
        this.isLoading = false
      })
    },

  },
  created () {
    this.isLoading = true
    this['user/getCouponNightPreview']().then(res => {
      if (res.status === 200) this.coupon = res.data
    }).finally(() => (this.isLoading = false))
  }
}
</script>

<style lang="sass" scoped>
.coupon-preview
  min-width: 375px
  &__title
    margin-bottom: 8px
  &__desc
    display: block
    text-align: center
  &__card
    width: 100%
    margin: 40px 0
  &__btn
    margin: 8px
    display: flex
    justify-content: space-around

</style>
